import { MunicipalPropertyLifecycleFilter } from "@/graphql/generated/graphql";

import { MunicipalPropertyCatalogFilter } from "./municipal-property-catalog-filter.model";

export const EMPTY_MUNICIPAL_PROPERTY_CATALOG_FILTER: MunicipalPropertyCatalogFilter = {
  municipalityId: null,
  search: "",
  usage: "ALL",
  lifecycle: MunicipalPropertyLifecycleFilter.Active,
};
